// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1mskM","requiredAsterisk":"Info_requiredAsterisk__3HDyf"};